import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/imgs/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-284671ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { id: "name" }, "dat.cash", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "join-beta-button hidden" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "beta-signup",
    target: "_blank",
    href: "https://6rf461aomqj.typeform.com/to/IIDgLYto"
  }, "Join Beta")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: "navbar",
    class: _normalizeClass({bg: _ctx.hasBackground, narrow: true})
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "router-link",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ], 2))
}